<template>

	<div>

    <div class="modal-overlay" v-if="modalActive || errorActive"></div>

		<!-- ACTIVATE SCREEN -->
	    <div class="activate-voucher" >
	      <h2 :style="getStyle('h2')" v-html="config.activate_sub_header_text"></h2>
        
	    </div>
	    
	    <div class="button-wrapper">

        <button v-on:click="confirm = true" :style="getStyle('button')">
         {{config.activate_button_text}}
        </button>

      </div>

      <div class="activate-voucher" >
        <p class="mt-1" :style="getStyle('p')">{{config.activate_disclaimer_text}}</p>
      </div>


      <!-- MODAL -->
      <div class="modal" v-if="unit_confirm">

        <div class="auto_selected_unit" v-if="autoSelectUnitName">
          <p class="mb-0 mt-0" :style="getStyle('p')">Confirm you're in</p>
          <h2 :style="getStyle('h2')" class="mb-2">{{autoSelectUnitName}}</h2>
        </div>
        <button v-on:click="confirmUnit" :style="getStyle('button')">Yes, i'm there</button>
        <button class="secondary"  v-on:click="changeUnit" >No, i'm somewhere else</button>
        
      </div>

      <!-- MODAL -->
      <div class="modal" v-if="select_unit">

        <div class="auto_selected_unit">
          <p class="mt-0 mb-2" :style="getStyle('p')">Where are you using this voucher?</p>
        </div>

        <select v-model="selected_unit">
          <option value="">Please select</option>
          <option v-for="unit in this.config.units" :value="unit.id">{{unit.name}}</option>
        </select>
        <button :disabled="!selected_unit" v-on:click="confirmUnit" :style="getStyle('button')">Take me to the voucher</button>


       
      </div>

      <!-- MODAL -->
      <div class="modal" v-if="confirm">

        {{config.activation_confirm_text}}
        <button class="mt-0" v-on:click="confirm = false" :style="getStyle('button')">{{config.activate_confirm_cancel_button_text}}</button>
        <button v-on:click="activateVoucher" :style="getStyle('button')">{{config.activate_confirm_confirm_button_text}}</button>
       
      </div>

	</div>

</template>

<script>
export default {
  name: 'ActivateVoucher',
  props: {
    email: String
  },
  data : function(){       
    return {
      unit_confirm :false,
      select_unit  :false,
      errorActive  : false,
      count        :30,
      selected_unit:'',
      confirm:false
    }
  },
  created : function(){

    // set selected unit to url if it exists
    if(this.$route.query.u){
      let unit = this.config.units.filter(unit => unit.id == this.autoSelectUnit);
        if(unit.length){
          this.selected_unit = unit[0].id;
      }

    }
    
    this.selectUnit();

  },
  computed: {
      config(){
          return this.$store.getters.getCamapignConfig;
      },

      loaded(){
          return this.$store.getters.getAppLoaded;
      },

      apiCampaignParams(){
          return this.$store.getters.getCampaignApiVars;
      },

      autoSelectUnit(){
        let show =  this.$route.query.u ? this.$route.query.u : false;
        let unit = this.config.units.filter(unit => unit.id == this.$route.query.u);
        return show && unit.length ? this.$route.query.u : false;
      },

      autoSelectUnitName(){
        if(this.autoSelectUnit){
          let unit = this.config.units.filter(unit => unit.id == this.autoSelectUnit);
          if(unit.length){
            return unit[0].name;
          }
        }
        return false;
      },

      modalActive(){
        return this.unit_confirm || this.select_unit || this.confirm;
      }
  },
  methods:{

    changeUnit()
    {
        this.unit_confirm = false;
        this.select_unit = true;
    },

    selectUnit()
    {
      if(this.autoSelectUnit)
        this.unit_confirm = true;
      else
        this.select_unit = true;
    },

    confirmUnit()
    {
      if(!this.selected_unit)
        return;
      this.$store.commit('SET_UNIT',this.selected_unit);
      this.unit_confirm = false;
      this.select_unit = false;
    },

    activateVoucher()
    {
      this.$store.commit('SET_SCREEN','voucher');
    }

    
  }
}
</script>

